import { render } from "./ResendInviteModal.vue?vue&type=template&id=24e44d8d&scoped=true"
import script from "./ResendInviteModal.vue?vue&type=script&lang=js"
export * from "./ResendInviteModal.vue?vue&type=script&lang=js"

import "./ResendInviteModal.vue?vue&type=style&index=0&id=24e44d8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e44d8d"]])

export default __exports__